import { gql, TypedDocumentNode } from "@apollo/client";

import { Maybe, PullRequest, QueryStackArgs, Run, Stack } from "types/generated";

export type StackPullRequestsTableRow = Pick<
  PullRequest,
  "id" | "authorLogin" | "createdAt" | "headBranch" | "headBranchURL" | "title" | "url"
> & {
  run: Pick<Run, "id" | "state" | "delta">;
};

type ListPullRequestsData = {
  stack: Maybe<Pick<Stack, "id"> & { pullRequests: StackPullRequestsTableRow[] }>;
};

export const LIST_PULL_REQUESTS: TypedDocumentNode<ListPullRequestsData, QueryStackArgs> = gql`
  query ListPullRequestsLegacy($id: ID!) {
    stack(id: $id) {
      id
      pullRequests {
        id
        authorLogin
        createdAt
        headBranch
        headBranchURL
        run {
          id
          delta {
            addCount
            changeCount
            deleteCount
            resources
            importCount
            forgetCount
            moveCount
            ignoreCount
            okCount
            rescueCount
            skipCount
            unreachableCount
            failedCount
          }
          state
        }
        title
        url
      }
    }
  }
`;
